import { LibConfig } from '../config';

export interface MappingServiceInterface {
  island_id: string;
  island_mfd_base_url: string;
  island_crm_base_url: string;
}

const CloudbedsDomains = {
  Dev: 'cloudbeds-dev.com',
  Prod: 'cloudbeds.com',
  Stage: 'cloudbeds-stage.com',
};

export const getBaseUrl = () => {
  const testDomain = localStorage.getItem('__api_domain');
  return testDomain || LibConfig.apiDomain;
};

export const getApiUrl = () => {
  const domain = getBaseUrl();
  switch (true) {
    case domain.includes(CloudbedsDomains.Prod):
      return 'https://api.cloudbeds.com';
    case domain.includes(CloudbedsDomains.Stage):
      return 'https://api.cloudbeds-stage.com';
    default:
      return 'https://api.cloudbeds-dev.com';
  }
};
